import { useFormContext } from 'react-hook-form';

export const useFormError = (name: string) => {
  const { errors } = useFormContext();

  return  name.split('.').reduce((acc: typeof errors, fieldName: keyof typeof errors) => acc?.[fieldName], errors);
};
